export default __webpack_public_path__ + "static/media/red-arrow.fae9cfc9.svg";